import Component from './ModelViewerBranch.component';

export default Component;
